import React, { useEffect, useState } from "react";
import { fetchHtml } from "../../lib/Fetching";
import moment from "moment";

export default function ClientSpecificationView({ at, id, name }) {
  const [html, setHtml] = useState("");

  useEffect(() => {
    fetchHtml("/products/client_specifications/" + id, { at, xhr: true }).then(html =>
      setHtml(html)
    );
  }, []);

  return (
    <div>
      <h4>Specification: {name}</h4>
        <p>{I18n.t("here_are_the_specifications", { name: name })}
          {moment
          .utc(at)
          .local()
          .format("DD-MM-YYYY")}
          {I18n.t("it_includes_all_the_specifications")}</p>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
